/** The app's own mark, used where a club has not set its logo (and on the sign-in page, before anybody knows which club): a flag on a green, in a ring. */
export function Emblem({ className = 'size-10' }: { className?: string }) {
  return (
    <svg viewBox="0 0 48 48" className={className} aria-hidden focusable="false" data-testid="emblem">
      <circle cx="24" cy="24" r="23" fill="#ffffff" />
      <circle cx="24" cy="24" r="21" fill="none" stroke="#00663a" strokeWidth="2" />
      <path d="M7.5 33c4.6-4.8 10.4-7.2 16.5-7.2S35.9 28.2 40.5 33a19 19 0 0 1-33 0z" fill="#78a68b" />
      <path d="M11 36.2c3.8-2.6 8.2-3.9 13-3.9s9.2 1.3 13 3.9" fill="none" stroke="#00663a" strokeWidth="1.2" opacity=".55" />
      <path d="M24 30V11" stroke="#1f2a24" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M24.4 11.4l10 3.4-10 3.6z" fill="#b5121b" />
      <ellipse cx="24" cy="30.3" rx="2.6" ry=".8" fill="#1f2a24" />
    </svg>
  )
}

/** A course seen from the clubhouse: for the sign-in page and empty screens. Decorative. */
export function CourseScene({ className = 'w-full' }: { className?: string }) {
  return (
    <svg viewBox="0 0 360 120" className={className} aria-hidden focusable="false" preserveAspectRatio="xMidYMax slice">
      <defs>
        <linearGradient id="gk-sky" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stopColor="#dbeee4" /><stop offset="1" stopColor="#f6f7f2" /></linearGradient>
      </defs>
      <rect width="360" height="120" fill="url(#gk-sky)" className="dark:opacity-0" />
      <g fill="#4f7d63" opacity=".55">
        <circle cx="40" cy="62" r="16" /><circle cx="62" cy="58" r="20" /><circle cx="86" cy="64" r="14" />
        <circle cx="268" cy="60" r="18" /><circle cx="292" cy="54" r="22" /><circle cx="318" cy="62" r="15" />
      </g>
      <path d="M0 78c60-18 120-22 180-16s120 4 180-8v66H0z" fill="#78a68b" />
      <g opacity=".22" fill="#ffffff">
        <path d="M0 88l40-6v38H0zM80 76l40-4v48H80zM160 70l40 1v49h-40zM240 72l40-3v51h-40zM320 66l40-8v62h-40z" />
      </g>
      <ellipse cx="210" cy="84" rx="62" ry="12" fill="#5f9a76" />
      <ellipse cx="128" cy="98" rx="34" ry="8" fill="#f1e7cf" />
      <path d="M104 98c8 2 16 3 24 2M114 102c8 1 14 1 22-1" stroke="#d8c79c" strokeWidth="1.2" fill="none" strokeLinecap="round" />
      <path d="M214 84V48" stroke="#1f2a24" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M214.4 48.6l16 5.4-16 5.6z" fill="#b5121b" />
      <ellipse cx="214" cy="84.4" rx="3.4" ry="1" fill="#1f2a24" />
      <path d="M0 108c80-8 160-10 240-6s100 4 120 2v16H0z" fill="#00663a" opacity=".9" />
    </svg>
  )
}
